export enum ProductReleaseFileRead {
    G3=12, 
    PMD2=13,
    G3GLT=41,
    PMD2GLT=42,
    TrakIT4=37
  }


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/interfaces/ProductReleaseFileReadEnum.model.ts